import { IMenuItem } from 'types/menu.js';

export const WARNING_BASE_LAND = '/warnings/home';
export const WARNING_BASE_MARINE = '/warnings/marine';

export const PRIMARY_MENU: IMenuItem[] = [
  {
    name: 'National',
    link: '/',
  },
  {
    name: 'Towns & Cities',
    link: '/towns-cities',
  },
  {
    name: 'Rural',
    link: '/rural',
  },
  {
    name: 'Marine',
    link: '/marine',
  },
  {
    name: 'Mountains & Parks',
    link: '/mountains-and-parks/national-parks',
  },
  {
    name: 'Maps & Radar',
    link: '/maps-radar/rain/radar',
  },
  {
    name: 'Warnings',
    link: WARNING_BASE_LAND,
  },
  {
    name: 'News',
    link: '/news/weather-news',
  },
  {
    name: 'Weather Videos',
    link: '/video-forecasts',
  },
];

export const PRIMARY_MENU_SKI: IMenuItem[] = PRIMARY_MENU.map((p) => {
  if (p.name === 'Mountains & Parks') {
    const item: IMenuItem = {
      name: 'Mountains & Parks',
      link: '/mountains-and-parks/ski-fields',
    };
    return item;
  }
  return p;
});

export const SECONDARY_MENU: IMenuItem[] = [
  {
    name: 'About MetService',
    link: 'https://about.metservice.com/our-company',
    target: '_blank',
  },
  {
    name: 'Weather for business',
    link: 'https://about.metservice.com/weather-for-business',
    target: '_blank',
  },
  {
    name: 'Learning Centre',
    link: 'https://about.metservice.com/learning-centre',
    target: '_blank',
  },
  {
    name: 'Contact Us',
    link: 'https://about.metservice.com/contact',
    target: '_blank',
  },
];
